/*jshint esversion: 9 */
import { mapGetters, mapActions} from 'vuex';
import Train from '@/components/ProjectTaktPlan/Train.component.vue';

export const TrainMixin = {
  components: {
    Train,
  },
  data: () => ({
  }),
  computed: {
    ...mapGetters('Train', [
      'getTrain',
      'getTrains',
      'getMoveTrainStartVariables',
      'getTrainLength',
      'getWorkpackagesInTakt'
    ]),
  },
  methods: {
    ...mapActions('Train', [
      'setTrainClosed',
      // 'setTrainStart',
      'setMoveTrainStartVariables',
      'taktareaChangePosition',
      // 'taktareaDelete',
      'taktareaInsert',
      'trainChangeValue'
    ]),
    ...mapActions('Ultra', [
      'updateUObject'
    ]),
    ...mapActions('ProjectCalendar', [
      'updateCalenderLookup'
    ]),
    moveTrainStartMouseDown(payload) {
      this.$refs[`taktarea${payload.taktarea_id}`][0].$el.style.width =
        `${this.$refs[`taktarea${payload.taktarea_id}`][0].$el.clientWidth + window.innerWidth}px`;
      this.setMoveTrainStartVariables({
        initial_x: payload.evt.pageX,
        train_id: payload.train_id,
        taktarea_id: payload.taktarea_id,
        initial_width: this.$refs[`placeholder_trainstart_${payload.train_id}`][0].$el.clientWidth,
        move_train_start: true,
      }
    );
    },
    moveTrainStartMouseUp() {
      this.draggable_disabled = false;
      if (this.getMoveTrainStartVariables.move_train_start === true) {
        this.setMoveTrainStartVariables({move_train_start: false});
      let taktplan_zoom = getComputedStyle(document.body).getPropertyValue('--taktplan_zoom');
      let waggon_width_string = getComputedStyle(document.body).getPropertyValue('--waggon_width');
      let waggon_width = parseInt(waggon_width_string.substring(0, waggon_width_string.length-2)) + parseInt(4);
      // let new_train_start = Math.round(this.$refs[`placeholder_trainstart_${this.getMoveTrainStartVariables.train_id}`][0].$el.clientWidth / (waggon_width * taktplan_zoom));
      let new_train_start = Math.round(document.getElementById(`placeholder_trainstart_${this.getMoveTrainStartVariables.train_id}`).clientWidth / (waggon_width * taktplan_zoom));
      if (new_train_start * (waggon_width * taktplan_zoom) === this.getMoveTrainStartVariables.initial_width) {
        // if (this.$refs[`placeholder_trainstart_${this.getMoveTrainStartVariables.train_id}`][0].$el.clientWidth < this.getMoveTrainStartVariables.initial_width) {
        if (document.getElementById(`placeholder_trainstart_${this.getMoveTrainStartVariables.train_id}`).clientWidth < this.getMoveTrainStartVariables.initial_width) {
          new_train_start--;
        } else {
          new_train_start++;
        }
      }
      this.updateUObject({
        url: [
          {projects: this.project_id},
          {trains: this.getMoveTrainStartVariables.train_id},
        ],
        update: {
          train_start: new_train_start
        }
      }).then(() => {
        // quick fix: always fire calendarlookup
        this.updateCalenderLookup(this.project_id).then(() => {
          // this.$refs[`taktarea${this.getMoveTrainStartVariables.taktarea_id}`][0].$el.style.width =
          document.getElementById(`taktarea${this.getMoveTrainStartVariables.taktarea_id}`).style.width =
          `calc((${this.getProjectLength(this.project_id) + 2} * (var(--workpackage_width) + 8px) + var(--project_taktplan_ta_header_width) * 1px + var(--project_taktplan_spatial_header_width) * 1px) * var(--taktplan_zoom))`;
        });
      });
      }
    },
    moveTrainStartMouseMove(evt) {
      if (this.getMoveTrainStartVariables.move_train_start) {
        let difference_x = evt.pageX - this.getMoveTrainStartVariables.initial_x;
        // for (var i = 0; i < this.$refs[`placeholder_trainstart_${this.getMoveTrainStartVariables.train_id}`].length; i++) {
        // for (var i = 0; i < this.$refs[`placeholder_trainstart_${this.getMoveTrainStartVariables.train_id}`].length; i++) {
          // this.$refs[`placeholder_trainstart_${this.getMoveTrainStartVariables.train_id}`][i].$el.style.width = `${this.getMoveTrainStartVariables.initial_width + difference_x}px`;
          document.getElementById(`placeholder_trainstart_${this.getMoveTrainStartVariables.train_id}`).style.width = `${this.getMoveTrainStartVariables.initial_width + difference_x}px`;
        // }
      }
    },
  }
};
